import { useState } from 'react'
import { Modal } from 'react-bootstrap'
import moment from 'moment'
import callAPI from '../../../../helpers/callAPI'
import CustomButton from '../../../../templates/UI/CustomButton/CustomButton'

// const isFutureMonth = (targetYr, targetMonth) => {
//     if (!targetYr || !targetMonth) return false
//     return moment(`${targetYr}-${targetMonth}`, 'YYYY-M').startOf('month').isAfter(moment(), 'month')
// }

const PerformanceTargetModal = ({ showSystemMessage, isOpen, handleClose, mode, adminId, adminName, roleId, roleName, managerId, managerName, createdByName, target, existingTargets = [] }) => {
    const [submitting, setSubmitting] = useState(false)

    // Delete disabled for now , may need it 
    // const [deleting, setDeleting] = useState(false)
    // const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false)

    const isEdit = mode === 'edit'
    const isRestore = mode === 'restore'
    // const editable = isRestore || !isEdit || isFutureMonth(target?.target_yr, target?.target_month)

    const handleSubmit = (e) => {
        e.preventDefault()

        const targetYr = parseInt(e.target.target_yr.value, 10)
        const targetQuarter = parseInt(e.target.target_quarter.value, 10)

        if (!isEdit && !isRestore) {
            const quarterExists = existingTargets.some(
                (t) => t.admin_id === parseInt(adminId, 10) && t.target_yr === targetYr && t.target_quarter === targetQuarter
            )
            if (quarterExists) {
                showSystemMessage('error', 'A target for this quarter already exists.')
                return
            }
        }

        setSubmitting(true)

        const body = {
            admin_id: parseInt(adminId, 10),
            db_date: isEdit ? target.db_date : moment().format('YYYY-MM-DD'),
            role_id: isEdit || isRestore ? target.role_id : roleId,
            manager_id: isEdit || isRestore ? target.manager_id : managerId,
            target_yr: targetYr,
            target_quarter: targetQuarter,
            target_month_amount: parseFloat(e.target.target_month_amount.value),
            status: e.target.status.value,
            notes: e.target.notes.value,
        }

        if (isEdit) {
            body.target_month = target.target_month
        }

        if (isRestore) {
            body.target_month = target.target_month
        }

        const url = isEdit ? `admin/performanceManagement/${target.perf_id}` : 'admin/performanceManagement'
        const method = isEdit ? 'PUT' : 'POST'

        callAPI(url, method, body).then((result) => {
            if (result.success === true) {
                showSystemMessage('success', result.message)
                handleClose(true)
            } else {
                showSystemMessage('error', result.errors.message)
                setSubmitting(false)
            }
        })
    }

    // Delete disabled for now
    // const handleDelete = () => {
    //     setDeleting(true)
    //     callAPI(`admin/performanceManagement/${target.perf_id}`, 'DELETE').then((result) => {
    //         if (result.success === true) {
    //             showSystemMessage('success', result.message)
    //             setConfirmDeleteOpen(false)
    //             handleClose(true)
    //         } else {
    //             showSystemMessage('error', result.errors.message)
    //             setDeleting(false)
    //         }
    //     })
    // }

    const getMonthStart = (yr, month) => moment(`${yr}-${month}`, 'YYYY-M').startOf('month').format('YYYY-MM-DD')
    const getMonthEnd = (yr, month) => moment(`${yr}-${month}`, 'YYYY-M').endOf('month').format('YYYY-MM-DD')
    const labelCell = 'py-2 pr-4 align-middle'
    const valueCell = 'py-2 align-middle'
    const fieldClass = 'form-control w-50'
    const showMonth = isEdit || isRestore
    const lockPeriod = isEdit || isRestore

    const title = isEdit
        ? 'Edit Performance Target'
        : isRestore
          ? 'Restore Performance Target'
          : 'Create New Performance Target'

    return (
        <>
            <Modal show={isOpen} onHide={() => handleClose(false)} centered>
                <form onSubmit={handleSubmit}>
                    <Modal.Header closeButton className="px-4 py-3">
                        <Modal.Title style={{ fontSize: '1.15rem' }}>
                            {title} for {adminName || target?.admin_name}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="px-4 py-3" style={{ fontSize: '1rem' }}>
                        {/* {isEdit && !editable && (
                            <div className="alert alert-warning mb-3">
                                This target cannot be edited because the month is in progress or has passed.
                            </div>
                        )} */}
                        <table className="table table-borderless m-0">
                            <tbody>
                                <tr>
                                    <td className={labelCell}>Date Created:</td>
                                    <td className={valueCell}>{moment(isEdit && target.db_date ? target.db_date : undefined).format('MMMM D, YYYY')}</td>
                                </tr>
                                <tr>
                                    <td className={labelCell}>Created By:</td>
                                    <td className={valueCell}>{isEdit ? (target.created_by_name || 'N/A') : createdByName}</td>
                                </tr>
                                <tr>
                                    <td className={labelCell}>Role:</td>
                                    <td className={valueCell}>{isEdit || isRestore ? (target.role || roleName) : roleName}</td>
                                </tr>
                                <tr>
                                    <td className={labelCell}>Manager:</td>
                                    <td className={valueCell}>{managerName || target?.manager_name || 'N/A'}</td>
                                </tr>
                                <tr>
                                    <td className={labelCell}>Target Year:</td>
                                    <td className={valueCell}>
                                        <input
                                            type="number"
                                            name="target_yr"
                                            className={fieldClass}
                                            defaultValue={lockPeriod ? target.target_yr : moment().year()}
                                            required
                                            disabled={lockPeriod}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td className={labelCell}>Target Quarter:</td>
                                    <td className={valueCell}>
                                        <select
                                            name="target_quarter"
                                            className={fieldClass}
                                            defaultValue={lockPeriod ? target.target_quarter : ''}
                                            required
                                            disabled={lockPeriod}
                                        >
                                            <option value="">Select...</option>
                                            <option value="1">Q1</option>
                                            <option value="2">Q2</option>
                                            <option value="3">Q3</option>
                                            <option value="4">Q4</option>
                                        </select>
                                    </td>
                                </tr>
                                {showMonth && (
                                    <tr>
                                        <td className={labelCell}>Target Month:</td>
                                        <td className={valueCell}>
                                            {moment()
                                                .month(target.target_month - 1)
                                                .format('MMMM')}
                                        </td>
                                    </tr>
                                )}
                                <tr>
                                    <td className={labelCell}>
                                        {isEdit || isRestore ? 'Target Amount:' : <>Target Amount<br />for the Quarter:</>}
                                    </td>
                                    <td className={valueCell}>
                                        <input
                                            type="text"
                                            name="target_month_amount"
                                            className={fieldClass}                                            
                                            defaultValue={isEdit ? target.target_month_amount : ''}
                                            onChange={e => {
                                                const rawValue = e.target.value
                                                const sanitizedValue = rawValue.replace(/[^0-9.]/g, '')
                                                const parts = sanitizedValue.split('.')
                                                const integerPart = parts[0] || '0'
                                                const decimalPart = parts.slice(1).join('').slice(0, 2)

                                                let value = integerPart

                                                if (sanitizedValue.includes('.')) {
                                                    value = decimalPart.length > 0 || rawValue.endsWith('.')
                                                        ? `${integerPart}.${decimalPart}`
                                                        : integerPart
                                                }

                                                e.target.value = value
                                            }}
                                            required
                                            // disabled={isEdit && !editable}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td className={labelCell}>Status:</td>
                                    <td className={valueCell}>
                                        <select
                                            name="status"
                                            className={fieldClass}
                                            defaultValue={isEdit ? target.status : 'P'}
                                            // disabled={isEdit && !editable}
                                        >
                                            <option value="A">Active</option>
                                            <option value="P">Pending</option>
                                        </select>
                                    </td>
                                </tr>
                                {!isEdit && (
                                    <tr>
                                        <td className={labelCell}>Notes:</td>
                                        <td className={valueCell}>
                                            <textarea
                                                name="notes"
                                                className="form-control"
                                                rows={3}
                                                maxLength={1024}
                                                defaultValue={isRestore ? (target.notes || '') : ''}
                                            />
                                        </td>
                                    </tr>
                                )}
                                {isEdit && (
                                    <>
                                        <tr>
                                            <td className={labelCell}>Start Date:</td>
                                            <td className={valueCell}>
                                                <input
                                                    type="date"
                                                    name="start_date"
                                                    className={fieldClass}
                                                    defaultValue={getMonthStart(target.target_yr, target.target_month)}
                                                    disabled
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className={labelCell}>End Date:</td>
                                            <td className={valueCell}>
                                                <input
                                                    type="date"
                                                    name="end_date"
                                                    className={fieldClass}
                                                    defaultValue={getMonthEnd(target.target_yr, target.target_month)}
                                                    disabled
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className={labelCell}>Notes:</td>
                                            <td className={valueCell}>
                                                <textarea
                                                    name="notes"
                                                    className="form-control"
                                                    rows={3}
                                                    maxLength={1024}
                                                    defaultValue={target.notes || ''}
                                                />
                                            </td>
                                        </tr>
                                    </>
                                )}
                            </tbody>
                        </table>
                    </Modal.Body>
                    <Modal.Footer className="px-4 py-3">
                        <CustomButton name="Save" type="submit" spin={submitting} />

                        {/* Delete disabled for now 
                        {isEdit && (
                            <CustomButton
                                name="Delete"
                                variant="danger"
                                type="button"
                                onClick={() => setConfirmDeleteOpen(true)}
                            />
                        )}
                        */}

                    </Modal.Footer>
                </form>
            </Modal>

            {/* Delete confirm modal disabled for now
            <Modal show={confirmDeleteOpen} onHide={() => setConfirmDeleteOpen(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Deletion</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to delete this performance target?</Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary" onClick={() => setConfirmDeleteOpen(false)}>
                        Cancel
                    </button>
                    <CustomButton name="Delete" variant="danger" type="button" spin={deleting} onClick={handleDelete} />
                </Modal.Footer>
            </Modal>
            */}
            
        </>
    )
}

export default PerformanceTargetModal
